import React, { FC } from 'react';
import styled from '@emotion/styled';
import { useTheme } from '@emotion/react';
import { BasketUsp } from '../basket-usp';
import { Flex } from '$components/layouts';
import { ITrustpilotTagModel } from '$models';
import { mq } from '$lib/helpers';
import { Text } from '$components/elements/text';
import { Link } from '$components/elements/link';
import { Image } from '$components/elements/image';

type TrustpilotUspProps = {
    data: ITrustpilotTagModel;
};

export const TrustpilotUsp: FC<TrustpilotUspProps> = ({ data }) => {
    const theme = useTheme();

    return (
        <Link href={data?.tagLink} target="blank">
            <BasketUsp icon="starFull" bgColor={theme.colors.checkoutGreyLight}>
                <ContentContainer flex justifyContent="space-between" alignItems="center">
                    <UspText as="h6" color={theme.colors.black} noSpacing>
                        {data?.tagText}
                    </UspText>
                    <Image width={100} height={20} src={data?.tagImage?.src} />
                </ContentContainer>
            </BasketUsp>
        </Link>
    );
};

export const ContentContainer = styled(Flex)({
    flexDirection: 'column',
    [mq('md')]: {
        flexDirection: 'row',
    },
});

export const UspText = styled(Text)(({ theme }) => ({
    [mq(0, 'md')]: {
        fontSize: theme.fontSizes.sm,
    },
}));
